module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Exchange-c371c7eb78ec290f85bd174ebf2634a3.svg";